import React, { useEffect, useMemo, useState } from "react";
import Container from "../../components/Layout/Container";
import ContentBlock from "../../components/Layout/ContentBlock";
import HamlSnippet from "../../components/globals/HamlSnippet";

function ReviewEmailsPage({ match }) {

  return (
    <Container
          location={{
            locationName: "Review Emails",
            locationUrl: match.url,
          }}
        >
        <HamlSnippet url="/front/marketing/review_emails" />
    </Container>
  );
}

export default ReviewEmailsPage;